import {DeliveryModes} from "../common/models/deliveryMode";
import {DeliveryTypes} from "../common/models/DeliveryType";

function makeOrderPayload({additionalInfo, featureToggles}) {
  const {dateOfBirth, phoneNumber, verificationCode, email, stateResidency} =
    additionalInfo;

  return {
    notes: makeNotes({featureToggles, additionalInfo}),
    ...names({featureToggles, additionalInfo}),
    date_of_birth: convertDateToMs(dateOfBirth),
    email: email ? email : undefined,
    phone_number: phoneNumber,
    state_residency: stateResidency,
    code: verificationCode || undefined,
    delivery_specification: makeDeliverySpecificationPayload({additionalInfo}),
    medical_id: makeMedicalId({additionalInfo}),
  };
}
function convertDateToMs(date) {
  if (typeof date === "string") {
    const time = new Date(date).getTime();
    return isNaN(time) ? undefined : time;
  }
  if (date instanceof Date) return date.getTime();

  return undefined;
}

function names({additionalInfo}) {
  const {firstName, lastName} = additionalInfo;
  return {
    first_name: firstName,
    last_name: lastName,
  };
}
function makeNotes({additionalInfo}) {
  const {notes} = additionalInfo;
  return notes;
}
function makeDeliverySpecificationPayload({additionalInfo}) {
  const {deliveryType, deliveryAddress, deliveryMode, scheduleTime} = additionalInfo;
  const _deliveryType =
    deliveryType && deliveryType.code ? deliveryType.code : deliveryType;
  if (!scheduleTime) {
    return {
      mode: deliveryMode || DeliveryModes.ASAP,
      type: _deliveryType,
      address:
        deliveryMode === DeliveryModes.EXPRESS && deliveryAddress
          ? deliveryAddress.addressObject
          : undefined,
    };
  }

  switch (scheduleTime.code) {
    case DeliveryModes.SCHEDULED:
      return {
        type: _deliveryType,
        address:
          deliveryAddress && _deliveryType === DeliveryTypes.DELIVERY
            ? deliveryAddress.addressObject
            : undefined,
        mode: scheduleTime.code,
        scheduled_start_time: scheduleTime.getStartTime8601(),
        scheduled_end_time: scheduleTime.getEndTime8601(),
      };
    default:
      return {
        type: _deliveryType,
        address:
          deliveryAddress && _deliveryType === DeliveryTypes.DELIVERY
            ? deliveryAddress.addressObject
            : undefined,
        mode: deliveryMode || DeliveryModes.ASAP,
      };
  }
}
function makeMedicalId({additionalInfo}) {
  const {medicalIdNumber, medicalIdExpirationDate} = additionalInfo;
  return medicalIdNumber
    ? {
        number: medicalIdNumber,
        expiration_date: medicalIdExpirationDate
          ? medicalIdExpirationDate.getTime()
          : null,
      }
    : undefined;
}

export default makeOrderPayload;
